import { createGlobalState } from '@vueuse/core'

export const useOwnerSessionExpired = createGlobalState(() => {
  const isOpen = ref(false)
  const customerId = ref<string | null>(null)

  const open = (id?: string | null) => {
    const ownerList = useOwnerListV2Store()
    customerId.value = id ?? ownerList.selectedStoreId ?? null
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
    customerId.value = null
  }

  return { isOpen, customerId, open, close }
})
